import { render, staticRenderFns } from "./CaseTypeFilter.vue?vue&type=template&id=7062b401&scoped=true"
import script from "./CaseTypeFilter.vue?vue&type=script&lang=js"
export * from "./CaseTypeFilter.vue?vue&type=script&lang=js"
import style0 from "./CaseTypeFilter.vue?vue&type=style&index=0&id=7062b401&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7062b401",
  null
  
)

export default component.exports